module.exports = __webpack_public_path__ + "static/miss-monique_3-33b86b42afdccb91342c6aff6346af97.jpg";